import { put, call, takeLatest, delay, select } from "redux-saga/effects";
import { ErrorHandler } from "../../utils/errorHandler";
import * as actions from "./actions";
import { getRequests, getResponse, getSingleRequests } from "./services";
//getting categories from the shared
function* __REQUESTS(action) {
  try {
    var payload = {
      requests: [],
    };
    const res = yield getRequests(action.payload);
    const data = res?.data;
    payload.requests = data?.result;
    if (res.status === 200) {
      yield put(actions.request_success(payload));
    }
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.request_fail({ error: errorMessage }));
  }
}
function* __RESPONSEtORequest(action) {
  try {
    let payload = action.payload.data;
    const res = yield getResponse(payload);
    if (res) {
      action.payload.success();
    }
    // yield put(actions.response_success(payload));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.failure(errorMessage);
    yield put(actions.response_fail({ error: errorMessage }));
  }
}

function* __SINGLEREQUESTS(action) {
  try {
    const res = yield getSingleRequests(action.payload.data?.request_id);
    const data = res?.data;
    action.payload.success(data?.approval_request);
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.failure(errorMessage);
  }
}

export function* requests() {
  yield takeLatest(actions.GET_REQUESTS, __REQUESTS);
}
export function* resREQ() {
  yield takeLatest(actions.RESPOND_REQUESTS, __RESPONSEtORequest);
}

export function* single_request() {
  yield takeLatest(actions.GET_SINGLE_REQUESTS, __SINGLEREQUESTS);
}
